import { IPlayer } from "../models/player.model";
import { IMedia } from "../models/media.model";
import { nuevoOptions } from "../models/nuevo";

import DOMPurify from 'dompurify';
import { VideoJsPlayer } from "video.js";
import { getCurrentVideo } from "helpers/current-video.helper";
import { IPlaylist } from "models/playlist.model";

export default function nuevoOptionsConfig(
  playerVideo: VideoJsPlayer,
  shareId: string,
  player: IPlayer | undefined,
  media: IMedia[] | undefined,
  playlist: IPlaylist | undefined,
): Partial<nuevoOptions> {

  const currentVideo = getCurrentVideo(playerVideo, media as IMedia[]);

  let opts: Partial<nuevoOptions> = {
    slideImage: player?.show_media_thumbnail ? currentVideo.thumbnails.timeline : '',
    log: true,
    video_id: `item-${shareId}`,
    resOnly: true,
    buttonForward: true,
    buttonRewind: true,
    playlistUI: playlist?.show_controls,
    rewindforward: 10,
    contextMenu: false,
    playsinline: true,
    title: DOMPurify.sanitize(currentVideo.title, {ALLOWED_TAGS: []}),
    videoInfo: player?.show_media_info,
    infoDescription: currentVideo.description ? DOMPurify.sanitize(currentVideo.description?.substring(0, player?.logo_image ? 100 : 150) + "...", {ALLOWED_TAGS: []}): '',
    resume: true,
    logomin: true,
    playlistID: "playlist",
    playlistMaxH: 200,
    zoomMenu: true,
    chapterMarkers: false,
    loop: media && media.length !== 0 && player?.show_loop,
    shareMenu: false,
    embed: player?.enable_embed_code
      ? `<iframe frameborder="0" width="${player.width}" height="${player.height}"  src="player.vod2.infomaniak.com/embed/${shareId}" allowfullscreen></iframe>`
      : "",
    url: player?.facebook_back_link ?? null,
    twitter_url: player?.twitter_back_link ?? null,
    twitter_related: player?.twitter_related ?? null,
    twitter_text: player?.twitter_via ?? null
  };

  if (
    player?.show_media_thumbnail &&
    media &&
    media.length > 0 &&
    media[0].thumbnails?.timeline !== void 0
  ) {
    opts = {...opts, ...defineThumbnail(media)};
  }

  if (player?.logo_image) {
    opts = {...opts, ...defineLogo(player)};
  }

  if (player?.show_default_logo) {
    opts = {...opts, ...defineDefaultLogo()};
  }

  // TODO when audio configuration will be possible
  // if (isAudioOnly ) {
  //   const audio_info = {
  //     cover: currentVideo.thumbnails.poster ?? player?.preload_image,
  //     artist: "Artist name",
  //     title: currentVideo.title,
  //     album: "Album name",
  //     genre: "Song genre",
  //     year: "2020"
  //   };
  //   opts = {
  //     ...opts, audioInfo: audio_info, videoInfo: false
  //   }
  // }

  return opts;
}

export function defineThumbnail(media: IMedia[]): Partial<nuevoOptions> {
  return {
    currentSlide: media[0].thumbnails?.timeline ?? "",
    slideType: "horizontal",
    slideWidth: 140,
    slideHeight: 100,
  };
}

function defineLogo(player: IPlayer): Partial<nuevoOptions> {
  const logoOpts = {
    logomin: true,
    logoposition: 'RT',
    logooffsetX: player.logo_margin_horizontal,
    logooffsetY: player.logo_margin_vertical,
    logo: player.logo_image,
  }

  switch (player.logo_anchor) {
    case "top_right":
      logoOpts.logoposition = "RT";
      break;
    case "top_left":
      logoOpts.logoposition = "LT";
      break;
  }

  return logoOpts;
}

function defineDefaultLogo(): Partial<nuevoOptions> {
  return {logocontrolbar: "/assets/images/byIk.png"};
}
